export default function normalizeImageData(imageData) {
  return {
    original_file_name: imageData.fileName, // eslint-disable-line
    file_name: imageData.relativeUri, // eslint-disable-line
    width: imageData.width,
    height: imageData.height,
  };
}



// WEBPACK FOOTER //
// ./app/components/text-editor/utils/normalize-image-data.js